module.exports = __webpack_public_path__ + "img/nav-design-diamondearrings.5cf25a2.jpg";